import { JoiEvent } from './events.data'

export interface WorkforceGroup {
  name: string // to somewhat maintain compatability, "name" will be used as the id field.  Note to others:  Never create a data structure that is referenced elsewhere that doesn't have an untouched id field
  realName: string
  members: string[]
}

export type WorkerStatus = 'accepted' | 'notInvited' | 'invited' | 'pending' | 'declined' | 'invite' | 'inactive' | 'sending'
export interface WFWorker {
  email?: string;
  uid?: string;
  photoURL?: string;
  displayName?: string;
  firstName?: string;
  lastName?: string;
  status?: WorkerStatus;
  role?: string;
  country?: string;
  lastLogin?: Date;
  is_loading?: Boolean;
  groups?: Array<string>;
  selected?: boolean;
  permissions?: string // this is really a mess, we use it as a single type throughout the app but the logic to create the string is a list.
}

export interface WorkerProfile {
  uid?: string
	aboutMe?: string
	company?: string
	title?: string
	phone?: string
}

export interface WorkerWithProfile extends WorkerProfile, WFWorker { id?: string, name?: string, missingAdditionalInfo?: boolean } // hacks for ease of use in entity selector // missingAdditionalInfo is for brief

// this is for filters only.  Tasks uses the more accurate maps by event id to worker groups.  However, need a single map for filters unless want to complicate that more.
export const getWorkersByEmailAndUidFromMultipleEvents = (events: { [eventId:string]: JoiEvent }): { workersByEmail: { [email:string]: WorkerWithProfile }, workersByUId: { [uid:string]: WorkerWithProfile } } => {
  const workersByEmail: { [email:string]: WorkerWithProfile } = {}
  const workersByUId: { [uid:string]: WorkerWithProfile } = {}
  Object.values(events).forEach(({ workforce }) => workforce.filter(w => !workersByEmail[w.email]).forEach(w => {
    workersByEmail[w.email] = w
    if (w.uid) workersByUId[w.uid] = w
  }))
  return { workersByEmail, workersByUId }
}

export interface ReinviteWorkerData {
  workerEmail: string
  eventId: string
}
